/* tslint:disable */

/**
 * Days of the week covered by a consumption average value:
 *   * SATURDAY
 *   * SUNDAY
 *   * WEEK_DAYS
 */
type TankConsumptionDays =
  'SATURDAY' |
  'SUNDAY' |
  'WEEK_DAYS';
namespace TankConsumptionDays {
  export const SATURDAY: TankConsumptionDays = 'SATURDAY';
  export const SUNDAY: TankConsumptionDays = 'SUNDAY';
  export const WEEK_DAYS: TankConsumptionDays = 'WEEK_DAYS';
  export function values(): TankConsumptionDays[] {
    return [
      SATURDAY,
      SUNDAY,
      WEEK_DAYS
    ];
  }
}

export { TankConsumptionDays }